<template>
    <span class="w-100">
        <el-date-picker
            v-model="value"
            v-bind="$attrs"
            @change="changeRange"
            :picker-options="pickerOptions"
        >
        </el-date-picker>
    </span>
</template>
<script>
export default {

    props: ['model_from','model_to'],
    data() {
        return {
            wire: null,
            pickerOptions: {
                shortcuts: [{
                    text: 'Week',
                    onClick(picker) {
                        const currentDate = moment();
                        const start = currentDate.clone().startOf('week').toDate();
                        const end = currentDate.clone().endOf('week').toDate();
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: 'Month',
                    onClick(picker) {
                        const currentDate = moment();
                        const start = currentDate.clone().startOf('month').toDate();
                        const end = currentDate.clone().endOf('month').toDate();
                        picker.$emit('pick', [start, end]);
                    }

                },{
                    text: 'This Year',
                    onClick(picker) {
                        const currentDate = moment();
                        const start = currentDate.clone().startOf('year').toDate();
                        const end = currentDate.clone().endOf('year').toDate();
                        picker.$emit('pick', [start, end]);
                    }
                }
                ,{
                    text: 'Prev Year',
                    onClick(picker) {
                        const currentDate = moment();
                        const start = currentDate.clone().subtract(1, 'years').startOf('year').toDate();
                        const end = currentDate.clone().subtract(1, 'years').endOf('year').toDate();
                        picker.$emit('pick', [start, end]);
                    }

                }

                ]
            },
            value: null,
        };
    },
    methods: {
        changeRange(range) {
            if (range === null) {
                range = [null,null];
            }
            // Null-guard: rescue script può istanziare Vue su nodo detached, this.wire = null.
            if (!this.wire) {
                const el = this.$el && this.$el.closest && this.$el.closest('div[wire\\:id]');
                if (el) this.wire = el.getAttribute('wire:id');
            }
            if (!this.wire || !window.Livewire) return;
            const comp = Livewire.find(this.wire);
            if (!comp) return;
            comp.set(this.model_from, range[0]);
            comp.set(this.model_to, range[1]);
        }
    },
    mounted() {
        const wireEl = this.$el && this.$el.closest && this.$el.closest('div[wire\\:id]');
        this.wire = wireEl ? wireEl.getAttribute('wire:id') : null;
        document.addEventListener('livewire:load', () => {
            if (!this.wire) return;
            const comp = Livewire.find(this.wire);
            if (!comp) return;
            let from = comp.get(this.model_from);
            let to = comp.get(this.model_to);
            // Element-UI parseDate(undefined/null) crash su daterange:
            // settiamo value SOLO se ENTRAMBI from e to validi, altrimenti null.
            this.value = (from && to) ? [from, to] : null;
        });

        document.addEventListener("DOMContentLoaded", () => {
            Livewire.hook('message.received', (message, component) => {
                if (!this.wire) return;
                if (component.id !== this.wire) return;
                const comp = Livewire.find(this.wire);
                if (!comp) return;
                let from = comp.get(this.model_from);
                let to = comp.get(this.model_to);
                // Stessa logica: skip se manca una delle due → evita parseDate crash.
                this.value = (from && to) ? [from, to] : null;
            });
        });
    }
};
</script>
